import 'npm:@awesome.me/webawesome/dist/webawesome.loader.js';

import 'npm:@awesome.me/webawesome/dist/components/icon/icon.js';
